import { IProjectDataState } from 'store/types/projectData'
import { getInitialDimensions } from 'utils'

export const getInitialState = (): IProjectDataState => ({
  past: [],
  present: {
    backgroundColor: '#000000',
    defaultHeight: getInitialDimensions().height,
    defaultWidth: getInitialDimensions().width,
    mediaItems: [],
    multilineAudios: []
  },
  future: [],
  processingItems: [],
  isLoading: false,
  pendingMediaIds: []
})
